const reportsReducer = (
  state = {
    loading: false,
    uploadLoading: false,
    data: null,
    total: null
  },
  action
) => {
  switch (action.type) {
    case "SET_REPORTS_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "PUT_REPORTS_DATA":
      return {
        ...state,
        data: action.payload.data
      };

    case "SET_TOTAL_REPORT_COUNT":
      return {
        ...state,
        total: action.payload
      };

    case "SET_UPLOAD_REPORT_LOADING":
      return {
        ...state,
        uploadLoading: action.payload.loading
      };

    case "RESET":
      return {
        loading: false,
        uploadLoading: false,
        data: null,
        total: null
      };

    default:
      return state;
  }
};
export default reportsReducer;
